import Grid from "@mui/material/Grid";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import {useOrganization} from "../../store/organization";

const settingsMain = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
  dots: false,
};

export function Reviews() {
  const { organization } = useOrganization();
  const landingDetails = organization.data.landingDetails;

  return (
    <Grid
      container={true}
      item={true}
      justifyContent="center"
      mt={{ xs: "32px", md: "80px", }}
      sx={{
        backgroundColor: "#000000",
        color: "#ffffff",
      }}
    >
      <Grid md={9} sm={12} xs={12} py={{ xs: "32px", md: "80px" }}>
        <Slider
          {...settingsMain}
        >
          {landingDetails.reviews.map((review, key) =>
            <div
              key={key}
              className="slick-slide tw-text-center"
            >
              <p className="tw-text-2xl">{review.text}</p>
              <p className="tw-text-sm tw-mt-4 tw-mb-5">{review.reviewer}</p>

              <Rating
                name="read-only"
                defaultValue={review.rate}
                readOnly={true}
                size="large"
                sx={{
                  "& .MuiRating-iconFilled": {
                    color: "#fde82b"
                  },
                }}
              />
            </div>
          )}
        </Slider>
      </Grid>
    </Grid>
  );
}
